module.exports = __webpack_public_path__ + "static/fonts/FuturaBookfont.f9f02ed.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/FuturaBookfont.ttf
// module id = 972
// module chunks = 113